import { NO_CAPTCHA_REQUIRED_STATUS } from 'src/dataLayer/localData/captcha'

const isCaptchaRequired = (captchaResponseToken) =>
  !(captchaResponseToken === NO_CAPTCHA_REQUIRED_STATUS)

export const formatCaptchaResult = (captchaResponseToken) => {
  if (!captchaResponseToken) {
    throw new Error('captchaResponseToken was missing')
  }
  return isCaptchaRequired(captchaResponseToken) ? { response: captchaResponseToken } : {}
}
